import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';


import { AppSettingsService } from 'src/services/appsettings.service';
import { AppSettings } from '~/core/models/appsettings';

import { routes } from 'src/routing/app-routing.module';
import { NgClass, NgFor, NgIf } from '@angular/common';

export class NavItem {
    public title: string = "";
    public icon: string = "";
    public Id?: string = "";
    public Count?: number = 0;
    public url: string = "";
    public Selected?: boolean = false;
    public roles?: string[] = [];
    public visible?: boolean = false;
}

interface Route {
    title: string;
    icon: string;
    path: string;
    isNav?: boolean;
    isSubNav?: boolean;
    roles?: string[];
}

interface SubNavItem {
    parent: string;
    title: string;
    icon: string;
    url: string;
}

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
    standalone: true,
    imports: [NgClass, NgFor, NgIf]
})

export class NavComponent {
    @Input() expand: boolean = false;
    @Output() setLayoutClass = new EventEmitter<void>();
    @Output() reloadPage = new EventEmitter();
    @Output() showSearch: EventEmitter<boolean> = new EventEmitter();

    public appIcon: string = "web_asset";
    public appTitle: string = "Application Mode";

    public menuIcon: string = "keyboard_double_arrow_right";
    public activeItem: NavItem = new NavItem();

    public navItems: NavItem[] = [];
    public navSubItems: SubNavItem[] = [];

    private _routes: Route[] = [...routes];
    private collapse: boolean = false;

    constructor(
        private router: Router,
        private appSettingsService: AppSettingsService
    ) { }


    public async ngOnInit() {
        await this.getRoutes();

        if (this.router?.url) {
            let routeUrl = this.router.url.split("?")[0];

            this.setActiveItem(this.navItems, routeUrl);
            this.setActiveItem(this.navSubItems, routeUrl);
        }
    }
    public toggleMenu(collapse: boolean = false) {
        this.collapse = collapse;
        this.menuIcon = collapse ? "keyboard_double_arrow_left" : "keyboard_double_arrow_right";

        this.setLayoutClass.emit();
    }

    public navigateTo(item: NavItem) {
        let allowNavigate: boolean = true;
        let storage = sessionStorage.getItem("__allowNavigate__");

        if (storage && storage === "false") {
            allowNavigate = confirm('WARNING: Changes have been made. Are you sure you want to leave without saving these changes?');
        }

        if (this.collapse) {
            this.collapse = false;
            this.setLayoutClass.emit();
        }

        if (allowNavigate) {
            this.router.navigateByUrl(item.url);
            this.activeItem = item;
        }
    }

    public toggleFullscreen() {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
            this.appIcon = "iframe";
            this.appTitle = "Web Mode";
        } else {
            document.exitFullscreen();
            this.appIcon = "web_asset";
            this.appTitle = "Application Mode";
        }
    }

    private async getRoutes() {
        this.navItems = [];
        this.navSubItems = [];

        await this.appSettingsService.getSettings().then((appSettings: AppSettings) => {
            this._routes.forEach((route: Route) => {
                if (route.isNav) {
                    let addItem: boolean = false;

                    if (route.roles?.length === 0) {
                        addItem = true;
                    } else if (route.roles) {
                        if (route.roles.some((r: string) => appSettings.roles.includes(r))) {
                            addItem = true;
                        }
                    } else {
                        addItem = true;
                    }

                    if (addItem) {
                        this.navItems.push(
                            {
                                title: route.title,
                                icon: route.icon,
                                url: route.path
                            }
                        );

                        this.getSubRoutes(route, appSettings.roles);
                    }
                }
            });
        });
    }

    private getSubRoutes(parent: Route, roles: string[]): void {
        this._routes.forEach((route: Route) => {
            if (route.isSubNav && route.path.startsWith(`${parent.path}/`)) {
                const addItem = (!route.roles || route.roles.length === 0) ||
                    (route.roles && route.roles.some((r: string) => roles.includes(r)));

                if (addItem) {
                    this.navSubItems.push({
                        parent: parent.title,
                        title: route.title,
                        icon: route.icon,
                        url: route.path
                    });
                }
            }
        });
    }

    private setActiveItem(items: Array<NavItem | SubNavItem>, routeUrl: string) {
        for (let item of items) {
            if (`/${item.url}` === routeUrl) {
                this.activeItem = item as NavItem;
                break;
            }
        }
    }
}
